import React, { useEffect, useRef } from "react";

// Guía corta para quien entra por primera vez: qué es cada cosa del mapa y cómo usarla. Sin datos de ningún cliente.
// `leyenda` = [{ texto, color }] con los estados y sus colores (los define App.js, para que no se desincronicen).
export default function Ayuda({ leyenda, correo, mailto, onInstalar, abrirInstalar, onCerrar }) {
    const iphone = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.matchMedia("(display-mode: standalone)").matches;
    const cerrar = useRef(null);
    useEffect(() => { if (cerrar.current) cerrar.current.focus(); }, []);

    return (
        <div className="hoja-fondo" role="dialog" aria-modal="true" aria-label="Cómo funciona el mapa" onMouseDown={(e) => { if (e.target === e.currentTarget) onCerrar(); }}>
            <div className="hoja hoja-ayuda">
                <header className="hoja-cab">
                    <h2>¿Cómo funciona?</h2>
                    <button type="button" className="icono" ref={cerrar} onClick={onCerrar} aria-label="Cerrar">×</button>
                </header>
                <div className="hoja-cuerpo">
                    <p className="ayuda-intro"><strong>Mejoremos el Barrio</strong> muestra los objetos de una organización (luminarias, postes, juegos, señales...), en qué estado están y cuánta vida útil les queda. Tú también puedes avisar si algo falla.</p>

                    <details className="paso-ayuda" open={!abrirInstalar}>
                        <summary><span className="paso">1</span>Elige una zona</summary>
                        <p>Pulsa <strong>Objetos</strong> y marca una o más zonas (comunas, condominios, proyectos...). El mapa se acerca, dibuja el contorno de la zona y muestra lo que hay dentro. Puedes compartir el enlace: guarda las zonas que elegiste.</p>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">2</span>Qué tipos de objeto ver</summary>
                        <p>En «Tipos de objeto» marca o desmarca cada tipo. Cada tipo tiene su propio color de relleno y al lado ves cuántos hay.</p>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">3</span>Estado de cada objeto</summary>
                        <p>El <strong>borde</strong> de cada punto indica su estado. Puedes ocultar los que no te interesan, por ejemplo mostrar solo los malos o quebrados.</p>
                        <ul className="leyenda">
                            {leyenda.map((e) => (
                                <li key={e.texto}><span className="punto-color" style={{ background: e.color }} />{e.texto}</li>
                            ))}
                        </ul>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">4</span>Año y vida útil</summary>
                        <p>Filtra por año de fabricación, año de instalación o vida útil total. En «Fin de vida útil» puedes ver qué ya cumplió su vida útil o la cumple pronto (en 1, 3 o 5 años). Los objetos sin ese dato quedan fuera mientras filtras.</p>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">5</span>Toca un punto</summary>
                        <p>Se abre su ficha: tipo, estado, dirección, años y vida útil restante, y un enlace para abrirlo en Google Maps.</p>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">6</span>Avisa si algo falla o falta</summary>
                        <p>En la ficha de un objeto pulsa <strong>Reportar un problema</strong>. Si lo que falta no está en el mapa, usa <strong>Reportar algo que falta</strong> y toca el lugar (o usa tu ubicación).</p>
                        <p>Puedes reportar <strong>de forma anónima</strong> o dejar tu celular (es opcional y no se publica). Recibirás un código como <code>R-8F3K2</code>: guárdalo y úsalo en «Consultar un reporte» para ver cómo va.</p>
                        <p>Puedes <strong>adjuntar hasta 3 fotos</strong> (con la cámara o desde la galería). Solo las ve el equipo que revisa los reportes: no se publican.</p>
                        <p>Un reporte no cambia el mapa por sí solo: una persona lo revisa primero.</p>
                    </details>

                    <details className="paso-ayuda">
                        <summary><span className="paso">7</span>Reportes resueltos</summary>
                        <p>Al final del panel puedes activar <strong>Reportes resueltos</strong>. Los objetos con un reporte ya solucionado (de los últimos 12 meses) se marcan con un círculo verde, con el problema y la fecha en que se resolvió. Nunca se muestran textos ni datos de quien reportó.</p>
                    </details>

                    <details className="paso-ayuda" open={!!abrirInstalar}>
                        <summary><span className="paso">8</span>Instálalo en tu celular</summary>
                        <p>Puedes tenerlo como una app en tu pantalla de inicio, sin pasar por ninguna tienda y sin ocupar casi espacio.</p>
                        {onInstalar && <p><button type="button" className="boton" onClick={onInstalar}>Instalar en este dispositivo</button></p>}
                        {iphone && <p>En iPhone: toca el botón <strong>Compartir</strong> de Safari y luego <strong>Añadir a pantalla de inicio</strong>.</p>}
                        {!onInstalar && !iphone && <p>En Chrome: menú ⋮ y luego <strong>Instalar aplicación</strong> (en Android también <strong>Añadir a la pantalla de inicio</strong>). En el computador también aparece un ícono de instalar en la barra de direcciones.</p>}
                        <p>Tus reportes quedan listados en «Consultar un reporte», solo en ese dispositivo.</p>
                    </details>

                    <p className="ayuda">¿Lo quieres con los datos de tu organización? Escríbenos a <a href={mailto}>{correo}</a>.</p>
                    <button type="button" className="boton" onClick={onCerrar}>Entendido</button>
                </div>
            </div>
        </div>
    );
}
